const BigDocIcon = ({
  title = '',
  style = {},
  width = 64,
  height = 64,
  onClick = () => {},
}: {
  title?: string;
  style?: object;
  height?: number;
  width?: number;
  onClick?: () => void;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // style={style}
      onClick={onClick}
    >
      {!!title && <title id="unique-id">{title}</title>}

      <rect width="64" height="64" rx="4" fill="#FCFCFC" />
      <path
        d="M48.7538 21.3379L39.9355 18.8183L37.416 10H19.7793C17.692 10 16 11.692 16 13.7793V49.2206C16 51.3079 17.692 52.9999 19.7793 52.9999H44.9745C47.0618 52.9999 48.7538 51.3079 48.7538 49.2206V21.3379Z"
        fill="var(--primary)"
      />
      <path
        d="M48.7539 21.3379V49.2206C48.7539 51.3079 47.0618 52.9999 44.9746 52.9999H32.377V10H37.416L39.9355 18.8183L48.7539 21.3379Z"
        fill="var(--primary)"
      />
      <path
        d="M48.7539 21.3379H39.9355C38.5498 21.3379 37.416 20.2041 37.416 18.8183V10C37.7436 10 38.0711 10.126 38.2978 10.378L48.3759 20.4561C48.6279 20.6828 48.7539 21.0103 48.7539 21.3379Z"
        fill="var(--primary)"
      />
      <path
        d="M39.9355 30.2402H24.8184C24.122 30.2402 23.5586 29.6768 23.5586 28.9805C23.5586 28.2842 24.122 27.7207 24.8184 27.7207H39.9355C40.6318 27.7207 41.1953 28.2842 41.1953 28.9805C41.1953 29.6768 40.6318 30.2402 39.9355 30.2402Z"
        fill="#FFF5F5"
      />
      <path
        d="M39.9355 35.2793H24.8184C24.122 35.2793 23.5586 34.7158 23.5586 34.0195C23.5586 33.3232 24.122 32.7598 24.8184 32.7598H39.9355C40.6318 32.7598 41.1953 33.3232 41.1953 34.0195C41.1953 34.7158 40.6318 35.2793 39.9355 35.2793Z"
        fill="#FFF5F5"
      />
      <path
        d="M39.9355 40.3184H24.8184C24.122 40.3184 23.5586 39.7549 23.5586 39.0586C23.5586 38.3623 24.122 37.7988 24.8184 37.7988H39.9355C40.6318 37.7988 41.1953 38.3623 41.1953 39.0586C41.1953 39.7549 40.6318 40.3184 39.9355 40.3184Z"
        fill="#FFF5F5"
      />
      <path
        d="M34.8965 45.3574H24.8184C24.122 45.3574 23.5586 44.794 23.5586 44.0977C23.5586 43.4013 24.122 42.8379 24.8184 42.8379H34.8965C35.5928 42.8379 36.1562 43.4013 36.1562 44.0977C36.1562 44.794 35.5928 45.3574 34.8965 45.3574Z"
        fill="#FFF5F5"
      />
      <path
        d="M32.377 45.3574H34.8965C35.5928 45.3574 36.1562 44.794 36.1562 44.0977C36.1562 43.4013 35.5928 42.8379 34.8965 42.8379H32.377V45.3574Z"
        fill="#E3E7EA"
      />
      <path
        d="M32.377 40.3184H39.9355C40.6318 40.3184 41.1953 39.7549 41.1953 39.0586C41.1953 38.3623 40.6318 37.7988 39.9355 37.7988H32.377V40.3184Z"
        fill="#E3E7EA"
      />
      <path
        d="M32.377 35.2793H39.9355C40.6318 35.2793 41.1953 34.7158 41.1953 34.0195C41.1953 33.3232 40.6318 32.7598 39.9355 32.7598H32.377V35.2793Z"
        fill="#E3E7EA"
      />
      <path
        d="M32.377 30.2402H39.9355C40.6318 30.2402 41.1953 29.6768 41.1953 28.9805C41.1953 28.2842 40.6318 27.7207 39.9355 27.7207H32.377V30.2402Z"
        fill="#E3E7EA"
      />
    </svg>
  );
};

export default BigDocIcon;
